import { ref, onBeforeUnmount } from "vue";
import { getCustomerCompanies, } from "@erp/shared/api/generated/wrappers/customer";
import { getCustomerPersons, } from "@erp/shared/api/generated/wrappers/customer";
export const useCompanyAutofill = () => {
    // FK ID
    const companyId = ref(null);
    const managerId = ref(null);
    // 표시 값
    const companyName = ref("");
    const managerName = ref("");
    const managerEmail = ref("");
    const managerPhone = ref("");
    // 콤보 목록
    const companyItems = ref([]);
    const managerItems = ref([]);
    // 전체 거래처 데이터 캐시 (선택 시 자동채움용)
    let companiesCache = [];
    /** 선택된 거래처의 전체 정보 */
    const selectedCompanyData = ref(null);
    // 디바운스 타이머
    let searchTimer = null;
    /** 업체 검색 (디바운스 300ms) */
    const searchCompanies = (keyword) => {
        if (searchTimer)
            clearTimeout(searchTimer);
        searchTimer = setTimeout(async () => {
            try {
                const companies = await getCustomerCompanies(keyword || undefined);
                companiesCache = companies;
                companyItems.value = companies.map((c) => ({
                    text: c.name,
                    value: c.id,
                }));
            }
            catch (error) {
                console.error("[useCompanyAutofill] 업체 검색 실패:", error);
                companyItems.value = [];
                companiesCache = [];
            }
        }, 300);
    };
    /** 담당자 목록 로드 */
    const loadManagers = async (cId) => {
        try {
            const persons = await getCustomerPersons(cId);
            managerItems.value = persons.map((p) => ({
                text: p.name,
                value: p.id,
                email: p.email ?? "",
                phone: p.phone ?? "",
            }));
        }
        catch (error) {
            console.error("[useCompanyAutofill] 담당자 목록 로드 실패:", error);
            managerItems.value = [];
        }
    };
    /** 업체 선택 핸들러 */
    const selectCompany = async (selected) => {
        if (!selected) {
            companyId.value = null;
            companyName.value = "";
            selectedCompanyData.value = null;
            managerItems.value = [];
            return;
        }
        if (typeof selected === "string") {
            // 수동 입력 (미등록 업체)
            companyId.value = null;
            companyName.value = selected;
            selectedCompanyData.value = null;
            managerItems.value = [];
            return;
        }
        // 목록에서 선택
        companyId.value = selected.value;
        companyName.value = selected.text;
        selectedCompanyData.value =
            companiesCache.find((c) => c.id === selected.value) ?? null;
        await loadManagers(selected.value);
    };
    /** 담당자 선택 핸들러 */
    const selectManager = (selected) => {
        if (!selected) {
            managerId.value = null;
            managerName.value = "";
            managerEmail.value = "";
            managerPhone.value = "";
            return;
        }
        if (typeof selected === "string") {
            // 수동 입력 (미등록 담당자)
            managerId.value = null;
            managerName.value = selected;
            return;
        }
        managerId.value = selected.value;
        managerName.value = selected.text;
        managerEmail.value = selected.email;
        managerPhone.value = selected.phone;
    };
    /** 기존 데이터 로드 시 초기화 */
    const initFromExisting = async (data) => {
        companyId.value = data.companyId ?? null;
        companyName.value = data.companyName ?? "";
        managerId.value = data.managerId ?? null;
        managerName.value = data.managerName ?? "";
        managerEmail.value = data.managerEmail ?? "";
        managerPhone.value = data.managerPhone ?? "";
        if (data.companyId) {
            await loadManagers(data.companyId);
        }
    };
    /** 모든 값 초기화 (새로 작성 시) */
    const reset = () => {
        companyId.value = null;
        managerId.value = null;
        companyName.value = "";
        managerName.value = "";
        managerEmail.value = "";
        managerPhone.value = "";
        companyItems.value = [];
        managerItems.value = [];
        selectedCompanyData.value = null;
        companiesCache = [];
    };
    // 컴포넌트 해제 시 디바운스 타이머 정리
    onBeforeUnmount(() => {
        if (searchTimer) {
            clearTimeout(searchTimer);
            searchTimer = null;
        }
    });
    return {
        companyId,
        managerId,
        companyName,
        managerName,
        managerEmail,
        managerPhone,
        companyItems,
        managerItems,
        selectedCompanyData,
        searchCompanies,
        selectCompany,
        selectManager,
        initFromExisting,
        reset,
    };
};
